import { render } from "./AProposView.vue?vue&type=template&id=0e7b1cc7&scoped=true"
import script from "./AProposView.vue?vue&type=script&lang=js"
export * from "./AProposView.vue?vue&type=script&lang=js"

import "./AProposView.vue?vue&type=style&index=0&id=0e7b1cc7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7b1cc7"]])

export default __exports__